import React, { useState, useContext, useEffect, useMemo } from "react";
import PageHeader from "components/common/PageHeader";
import Hero from "./Hero";
import AppContext from "context/Context";
import Services from "./Services";
import { Accordion, Card, Col, Container, Form, Row } from "react-bootstrap";
import FaqAccordionItem from "../faq/faq-accordion/FaqAccordionItem";
import { faqAccordions as faqsData } from "data/faqs";
import PdfDownload from "./PdfDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import NavbarStandard from "./NavbarStandard";
import { useTranslation } from "react-i18next";
import Footer from "./Footer";
import LandingBackground from "assets/img/landing_background_bottom.jpg";
import WhatsApp from "assets/img/whatsapp.png";
import DownloadDoc from "assets/img/download_document.png";
import styles from "./landing.module.css";
import LandingButtons from "./LandingButtons";
import Carousel from "./Carousel";
import carouselImg from "assets/img/e-learning/courses/course8.png";
import jeddahmunicipality from "assets/img/jeddah-municipality.png";
import momra from "assets/img/momra.png";
import tga from "assets/img/tga.png";
import { getAllDatabaseRecords, getDatabaseRecord } from "components/workflow/WorkflowHelper";
import createMarkup from "helpers/createMarkup";
import * as Constants from "../../../common/constants";
import { useNavigate, useParams } from "react-router-dom";
import LoaderIcon from "components/custom/Preloader";
import * as General from "common/general";
import jwtDecode from "jwt-decode";
const IMAGE_EXTENSIONS = ["png", "jpg", "jpeg", "gif", "bmp", "webp", "svg"];

const Landing = () => {
	const navigate = useNavigate();
	document.addEventListener("DOMContentLoaded", function () {
		const cssToRemove = document.getElementById("css-to-remove");
		if (cssToRemove) {
			cssToRemove.parentNode.removeChild(cssToRemove);
		}
	});
	const encryptStorage1 = new EncryptStorage("secret-key-value", {
		prefix: "@mwan",
	});
	const [storedLoggedInUserInfo, setStoredLoggedInUserInfo] = useState(() => {
		const encryptStorage1 = new EncryptStorage("secret-key-value", { prefix: "@mwan" });
		return encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
	});
	const LoginImage = localStorage.getItem("loginImage");

	const loginlink = "/login";
	const [heroSlider, setHeroSlider] = useState([]);
	const [aboutUs, setAboutUs] = useState([]);
	const [partners, setPartners] = useState([]);
	const [news, setNews] = useState([]);
	const params = useParams();
	const filePath = params["*"];
	const safeAtob = (base64) => {
		try {
			// Remove any non-Base64 characters
			const cleaned = base64.replace(/[^A-Za-z0-9+/=]/g, "");
			return atob(cleaned);
		} catch (e) {
			console.error("Failed to decode base64:", e);
			return null;
		}
	};

	const createBlobUrlFromBase64 = (base64, extension) => {
		if (!base64) return null;

		const isPdf = extension === "pdf";
		const mimeType = isPdf ? "application/pdf" : `image/${extension}`;

		const byteCharacters = safeAtob(base64);
		if (!byteCharacters) return null;

		const byteArray = new Uint8Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteArray[i] = byteCharacters.charCodeAt(i);
		}

		const blob = new Blob([byteArray], { type: mimeType });
		return URL.createObjectURL(blob);
	};

	const {
		config: { isDark, isRTL },
	} = useContext(AppContext);
	const [t, i18n] = useTranslation();
	const [faqs] = useState(faqsData);
	const language = isRTL ? "ar" : "en";
	const formatDate = (date, language) => {
		const locale = language === "ar" ? "ar-EG" : "en-US"; // Choose Arabic or English locale
		return new Intl.DateTimeFormat(locale, {
			year: "numeric",
			day: "numeric",
			month: "long",
		}).format(new Date(date));
	};
	const [redirected, setRedirected] = useState(() => localStorage.getItem("landing-redirected") === "true");
	const [loadingRedirect, setLoadingRedirect] = useState(false);
	const [checkingAuth, setCheckingAuth] = useState(true);
	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await General.GetHomeSlider();

				if (response?.data?.dataBaseContent) {
					// Map dataBaseContent to the desired structure
					const mappedData = await Promise.all(
						response.data.dataBaseContent.map(async (item) => {
							const fileResponse = await General.GetFile(item.imageUrl);
							const extension = filePath?.split(".").pop()?.toLowerCase();
							return {
								title: t(item.title),
								subtitle: t(item.subTitle),
								imageUrl: createBlobUrlFromBase64(fileResponse.message, extension),
							};
						})
					);

					// Update state with the fetched and mapped data
					setHeroSlider((prev) => [...prev, ...mappedData]); // Append new data to existing
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching slider data:", error);
			}
			try {
				const response = await General.GetAboutUs();
				if (response?.data?.dataBaseContent) {
					const mappedData = response.data.dataBaseContent.map((item) => ({
						title: t(item.aboutTitle),
						aboutText: t(item.aboutText),
					}));

					setAboutUs((prev) => [...prev, ...mappedData]);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching about data:", error);
			}
			try {
				const response = await General.GetPartners();
				if (response?.data?.dataBaseContent) {
					const mappedData = await Promise.all(
						response.data.dataBaseContent.map(async (item) => {
							const fileResponse = await General.GetFile(item.image);
							const extension = filePath?.split(".").pop()?.toLowerCase();
							return {
								id: item.id,
								title: t(item.title),
								image: createBlobUrlFromBase64(fileResponse.message, extension),
								order: item.order,
							};
						})
					);
					const sortedData = mappedData.sort((a, b) => a.order - b.order);
					setPartners((prev) => [...prev, ...sortedData]);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching partners data:", error);
			}
			try {
				const response = await General.GetNews();
				if (response?.data?.dataBaseContent) {
					const mappedData = await Promise.all(
						response.data.dataBaseContent.map(async (item) => {
							const fileResponse = await General.GetFile(item.image);
							const extension = filePath?.split(".").pop()?.toLowerCase();
							return {
								id: item.id,
								title: t(item.title),
								description: t(item.description),
								image: createBlobUrlFromBase64(fileResponse.message, extension),
							};
						})
					);
					setNews((prev) => [...prev, ...mappedData]);
				} else {
					console.error("Invalid response structure:", response);
				}
			} catch (error) {
				console.error("Error fetching news data:", error);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		const handleStorage = async () => {
			const encryptStorage1 = new EncryptStorage("secret-key-value", { prefix: "@mwan" });
			const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
			setStoredLoggedInUserInfo(userInfo);
		};

		window.addEventListener("storage", handleStorage);
		return () => window.removeEventListener("storage", handleStorage);
	}, []);

	useEffect(() => {
		const doRedirect = async () => {
			if (storedLoggedInUserInfo && !redirected) {
				const hasAccessTo = (path) => {
					return Object.values(storedLoggedInUserInfo?.userCompanyDictionary).some((company) =>
						company.some((item) => item.permissionResponseList.some((permission) => permission.menuResponseList.some((menu) => menu.to === path)))
					);
				};

				const decodedAccessToken = jwtDecode(encryptStorage1.getItem(Constants.AccessTokenKeyInLocalStorage));
				var userCompanies = await General.GetUserCompanies(decodedAccessToken.sub);

				localStorage.setItem(
					"loggedInUserInfo",
					JSON.stringify({
						fullName: storedLoggedInUserInfo.fullName,
						email: storedLoggedInUserInfo.email,
						mobileNumber: storedLoggedInUserInfo.mobileNumber,
						idNumber: storedLoggedInUserInfo.idNumber,
						userId: storedLoggedInUserInfo.userId,
						companyId: userCompanies?.length > 0 ? userCompanies[0].companyId : null,
						firstName: storedLoggedInUserInfo.firstName,
						lastName: storedLoggedInUserInfo.lastName,
						companyName: userCompanies?.length > 0 ? userCompanies[0].companyName : null,
					})
				);

				const hasWorkflowList = hasAccessTo("/workflowList");
				const hasUserTask = hasAccessTo("/userTasks");
				setLoadingRedirect(true); // 🔹 hide iframe right away
				setRedirected(true);

				if (hasWorkflowList) {
					navigate("/workflowList", { replace: true });
				} else if (hasUserTask) {
					navigate("/userTasks", { replace: true });
				} else {
					navigate("/workflowHistory", { replace: true });
				}
				localStorage.setItem("landing-redirected", "true"); // remember redirect
			}
			setCheckingAuth(false); // ✅ finished checking
		};
		doRedirect();
	}, [storedLoggedInUserInfo, navigate, redirected]);
	useEffect(() => {
		setLoadingRedirect(window.self !== window.top);
	}, []);
	if (loadingRedirect) {
		return <LoaderIcon />;
	}
	return (
		<div className={`${styles.backgroundWhite}`}>
			<NavbarStandard />
			{storedLoggedInUserInfo ? (
				<>
					<Hero titleText={heroSlider} />
					<div
						className={`${styles.backgroundStyles}`}
						style={{
							backgroundImage: `url(${LandingBackground})`,
						}}
					>
						<Container className={`${styles.padding35em}`}>
							{aboutUs.map((text, index) => (
								<div key={index}>
									<h2 className={`${isRTL ? styles.landingTitleAr : styles.landingTitle}`}>{text.title}</h2>
									<div className={`${styles.landingText} ${styles.size18}`} dangerouslySetInnerHTML={createMarkup(text.aboutText)} />
								</div>
							))}
						</Container>
						<LandingButtons textColor="#ffffff" />
					</div>
					{news.length > 0 && (
						<Container className={`${styles.padding35em} `}>
							<h2 className={`${isRTL ? styles.landingTitleAr : styles.landingTitle}`}>{t("Latest news")}</h2>
							<Carousel dots={true} slidesToShowLarge={3} infinite={false} slidesToShowMid={2} slidesToShowS={1}>
								{news.map((item) => (
									<div key={item.id} className={styles.carouselcontainer}>
										<div className={styles.carouselImage} style={{ backgroundImage: `url(${item.image})` }}></div>
										<div className={isRTL ? styles.carouselTitleAr : styles.carouselTitle}>{t(item.title)}</div>
										<div className={isRTL ? styles.carouselDateAr : styles.carouselDate}>
											<FontAwesomeIcon icon="fa-regular fa-clock" className={styles.textGreen} />
											{item.date && formatDate(item.date, language)}
										</div>
									</div>
								))}
							</Carousel>
						</Container>
					)}
					{partners.length > 0 && (
						<Container className={`${styles.padding35em} `}>
							<h2 className={`${isRTL ? styles.landingTitleAr : styles.landingTitle}`}>{t("Success partners")}</h2>
							<Carousel dots={false} infinite={false} slidesToShowLarge={5} slidesToShowMid={3} slidesToShowS={2}>
								{partners.map((item) => (
									<div key={item.id} className={styles.carouselPartnercontainer}>
										<img className={styles.carouselPartnersImage} src={item.image} />
									</div>
								))}
							</Carousel>
						</Container>
					)}
				</>
			) : (
				<Row>
					<Col md={6}>
						<div className="content">
							<iframe src={loginlink} className={`${styles.iframeSize}`} />
						</div>
					</Col>
					<Col
						md={6}
						className={`${styles.loginImage}`}
						style={
							LoginImage
								? {
										backgroundImage: `url(${LoginImage})`,
										backgroundSize: "cover",
										backgroundPosition: "center",
										backgroundRepeat: "no-repeat",
								  }
								: {}
						}
					></Col>
				</Row>
			)}
			<Footer pageName="Landing"></Footer>
		</div>
	);
};

export default Landing;
